/**
 * パートナーユーザーへの配車板開放判定（一時措置 / #4669）
 *
 * 帳票出力・通知機能を AWS 環境で先行検証するため、パートナーユーザーにも
 * 配車板を表示する。有効化は `.env.development`（ローカル）と `.env.dev`（AWS dev）
 * にのみ環境変数を置くことで行い、顧客が触る stg / prestg / prod では
 * 変数が未設定のため有効化されない。
 *
 * 本開放（パートナーユーザーを追加すれば配車板が見える状態）に切り替える際は、
 * このファイルごと削除し、参照元の条件式と各 .env の環境変数も併せて外すこと。
 */

/**
 * パートナーユーザーに配車板を表示してよい環境かどうか。
 * オーナー（拠点）ユーザーの表示制御には用いない。
 */
export const canPartnerSeeDispatchBoard = (): boolean =>
  import.meta.env.VITE_PARTNER_DISPATCH_BOARD_ENABLED === 'true'
